import * as React from 'react';
import {observer} from 'mobx-react';
import {action, computed, observable} from 'mobx';
import {UIState} from 'data/UIState';
import {UnderBoxToLogin} from "components/login/UnderBoxToLogin";
import {UnderLogin} from "components/login/UnderLogin";

import Step1Basics, {IBasicsData} from "components/signup/Step1Basics";
import Step2Account, {IAccountData} from "components/signup/Step2Account";


import Step5Complete from "components/signup/Step5Complete";
import Step4Fitbit from "components/signup/Step4Fitbit";
import {Step3Profile} from "components/signup/Step3Profile";

import './Signup.pcss';
import {DATAGetLocations} from "data/data";
import {ILocation} from "data/entities/ILocation";
import Step3BWebinar from "./Step3BWebinar";
import {Alert} from "data/Alert";
import UserDataSource from "data/UserDataSource";

@observer
export class Signup extends React.Component<ISignupProps> {

  @observable initialized = false;

  @observable step = STEPS.WHO;

  @computed get isWhoAndTermsStep() { return this.step===STEPS.WHO; }
  @computed get isAccountStep() { return this.step===STEPS.ACCOUNT; }
  @computed get isProfileStep() { return this.step===STEPS.PROFILE; }
  @computed get isFitBitStep() { return this.step===STEPS.FITBIT; }
  @computed get isWebinarRegistrationStep() { return this.step===STEPS.WEBINAR; }
  @computed get isCompleteStep() { return this.step===STEPS.COMPLETE; }

  @observable step1BasicsData:IBasicsData;
  @observable step2AccountData:IAccountData;
  @observable pleaseWait = false;
  @observable locations:ILocation[] = [];

  constructor(props) {
    super(props);
    if(UIState.user && UIState.user.agreedToTerms) {
      this.setStep(STEPS.COMPLETE);
    } else {
      DATAGetLocations()
        .then(action((locations: ILocation[]) => {
          this.locations = locations;
          if (!UIState.settings.ASK_FOR_EMPLOYEE_OR_SPOUSE
            && this.locations.length == 0
            && !UIState.settings.ENABLE_GDPR
          ) {
            this.setStep(STEPS.ACCOUNT);
          }
          this.initialized = true;
        }))
        .catch(() => {
          Alert.alert('It appears that the Internet may not be available right now. Please make sure your connection is good and try again.');
        });
    }
  }

  @action continueFromStep1Basics = (data:IBasicsData) => {
    this.step1BasicsData = data;
    if(UIState.user) {
      UIState.signupInProgress = true;

      // UPDATE
      UserDataSource.saveUserTermsAccepted(UIState.user)
        .then(action(()=>{
          this.setStep(STEPS.PROFILE) ;
        }))
        .catch(()=>{
          Alert.alert('It appears that the Internet may not be available right now. Please make sure your connection is good and try again.');
        });
    } else {
      this.setStep(STEPS.ACCOUNT) ;
    }
  }

  @action continueFromStep2Account = (data:IAccountData) => {
    this.pleaseWait = true;
    this.step2AccountData = data;
    UIState.createUserAccount({
      email:this.step2AccountData.email,
      employeeId:this.step2AccountData.employeeId,
      extra:this.step1BasicsData.extra,
      firstName:this.step2AccountData.firstName,
      lastName:this.step2AccountData.lastName,
      password:this.step2AccountData.password,
      employeeOrSpouse:this.step1BasicsData.employeeOrSpouse,
      spouseName:this.step1BasicsData.employeeName,
      locationId:this.step1BasicsData.location ? this.step1BasicsData.location._id : '',
    })
      .then(()=>{
        this.setStep(STEPS.PROFILE) ;
        this.pleaseWait = false;
      })
      .catch((errorMessage:string)=>{
        Alert.alert(errorMessage);
        this.pleaseWait = false;
      });

  }

  @action continueFromStep3Profile = () => {

    if(UIState.settings.ENABLE_WEIGH_IN) {
      this.setStep(STEPS.WEBINAR);
    } else if(UIState.settings.ENABLE_TRACKERS) {
      this.setStep(STEPS.FITBIT) ;
    } else {
      this.setStep(STEPS.COMPLETE);
    }
  }

  @action continueFromStep3BWebinar = () => {
    if(UIState.settings.ENABLE_TRACKERS) {
      this.setStep(STEPS.FITBIT) ;
    } else {
      this.setStep(STEPS.COMPLETE);
    }
  }

  @action continueFromStep4Fitbit = () => {
    this.setStep(STEPS.COMPLETE);
  }

  @action continueToDashboard = () => {
    UIState.loadDashboard();
  }

  private setStep = (step:number) => {
    this.step = step;
    console.log("SignUp setStep");
    window.scrollTo(0, 0);
    try { document.getElementsByClassName('signup')[0].scrollTop = 0; } catch(e){ }
  }

  @computed get backgroundStyle() {
    return {backgroundImage:`url('${UIState.settings.BG}')` };
  }

  render() {
    document.body.style.overflow = "inherit";

    return (
      <div className="signup">
        <div className="signup-content" style={this.backgroundStyle}>
          <div className="col" style={{borderTop:'8px solid #243294'}}>
            <form name="signup">
              {this.isWhoAndTermsStep && <Step1Basics continue={this.continueFromStep1Basics} locations={this.locations} />}
              {this.isAccountStep && <Step2Account continue={this.continueFromStep2Account} pleaseWait={this.pleaseWait} /> }
              {this.isProfileStep && <Step3Profile continue={this.continueFromStep3Profile} pleaseWait={this.pleaseWait} /> }
              {this.isWebinarRegistrationStep && <Step3BWebinar continue={this.continueFromStep3BWebinar} /> }
              {this.isFitBitStep && <Step4Fitbit continue={this.continueFromStep4Fitbit} /> }
              {this.isCompleteStep && <Step5Complete continue={this.continueToDashboard} /> }
            </form>
          </div>
        </div>
        <UnderBoxToLogin hideSignInLink={UIState.settings.ENABLE_SAML_SSO || this.isCompleteStep} />
        <UnderLogin />
      </div>
    );
  }
}






interface ISignupProps {
}

const STEPS = {
  WHO:1,
  ACCOUNT:2,
  PROFILE:3,
  WEBINAR:4,
  FITBIT:5,
  COMPLETE:10
}



